import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TApplicationUserRelation, TApplicationUserRelationPayloadRequest, TApplicationUserRelationResponse, adaptApplicationUserRelationFromResponse, adaptApplicationUserRelationToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_APPLICATION_USER_RELATION } from '../../backend-paths';


export const applicationUserRelationCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_APPLICATION_USER_RELATION}`,
	(payload: TApplicationUserRelationPayloadRequest, thunkApi) => {
		const dataRequest = adaptApplicationUserRelationToRequest(payload);

		return HttpService.post<TApplicationUserRelationResponse>(BACKEND_ADMIN_APPLICATION_USER_RELATION, dataRequest).then(result => {
			return adaptApplicationUserRelationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplicationUserRelation> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationUserRelationCreateSlice = createSlice({
	name: 'applicationUserRelationCreateSlice',
	initialState,
	reducers: {
		clearApplicationUserRelationCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationUserRelationCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[applicationUserRelationCreateApi.fulfilled.type]: (state, action: PayloadAction<TApplicationUserRelation>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationUserRelationCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useApplicationUserRelationCreateSelector = () => useAppSelector(state => state[applicationUserRelationCreateSlice.name]);

export const { clearApplicationUserRelationCreate } = applicationUserRelationCreateSlice.actions;
